import React, { ReactNode, useContext } from "react"
import { RouteProps, Route, Redirect } from "react-router-dom"
import AuthContext from "../../context/AuthContext"

type Props = {
    children: ReactNode
}

function PrivateRoute({ children, ...restProps }: Props & RouteProps) {
    const auth = useContext(AuthContext)
    return (
        <Route
            {...restProps}
            render={({ location }) =>
                auth?.isAuthenticated() ? (
                    children
                ) : (
                    <Redirect
                        to={{ pathname: "/", state: { from: location } }}
                    />
                )
            }
        />
    )
}

export default PrivateRoute
